import { IDealerInfo, IUserInfo, AddressType, IAccountAddressDto } from "@/types";
import { IDealerCodeItem } from "@/types/DealerCodeItem";
import { oc } from "ts-optchain";

export class DealerUtil {
    public static hasAccessToAllBranches(dealerCodes: IDealerInfo[], user: IUserInfo) {
        return dealerCodes.length > 1 && user.DealerRange !== "*";
    }

    public static dealerFilter(currentDealerSelection: any, allPrimaryDealerCodes: string[]): string[] {
        if (currentDealerSelection.hasOwnProperty("value") && currentDealerSelection.value === "All Branches") {
            return allPrimaryDealerCodes;
        } else {
            return currentDealerSelection.DealerCodes.replace(/\s/g, "").split(",");
        }
    }

    public static determineCurrentDealerSelection(
        dealerCodes: IDealerInfo[],
        user: IUserInfo,
        hasAccessToAllBranches: boolean,
        isShoppingCart?: boolean
    ): any {
        if (!isShoppingCart && hasAccessToAllBranches) {
            return DealerUtil.AllBranches();
        } else {
            let currentDealerSelection = dealerCodes.find((dealer) => dealer.PrimaryDealerCode === user.DealerCode);
            
            // Secondary Dealers will result in `currentDealerSelection = undefined`, so loop through dealer codes
            // and find matching entry. If this fails, we still return undefined. This should be rare to impossible.
            if (!currentDealerSelection) {                
                let dealerSelectionObj; 

                for (let i = 0; i < dealerCodes.length; i++) {
                    dealerSelectionObj = dealerCodes[i];
                    let codes = dealerCodes[i].DealerCodes.split(",").map((code) => code.trim());
        
                    if (codes.includes(user.DealerCode)) {
                        return dealerSelectionObj;
                    }
                }
            }

            return currentDealerSelection;
        }
    }

    public static AllBranches(): IDealerCodeItem {
        return {
            value: "All Branches",
            DisplayWithSubDealers: "All Branches",
        };
    }

    public static findDealerAddress(dealers: IDealerInfo[], dealerCode: string, addressType: AddressType): IAccountAddressDto|undefined {

      const dealer = dealers.find((x) => x.PrimaryDealerCode === dealerCode);

      if (!dealer) {
        return undefined;
      }

      return oc(dealer)
        .Addresses([])
        .find((x) => x.AddressType === addressType);
    }
}
